import io from 'socket.io-client';
import { SOCKET_URL } from '@coligo-org/fe-common/constants';

let socket = null;

export const createSocket = options => {
  if (socket) {
    socket.disconnect();
  }
  socket = io(SOCKET_URL, options);
  return socket;
};

export const getSocket = () => {
  if (!socket) {
    return null;
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
